import React from 'react';
import ReactDOM from 'react-dom/client';
import ScopedCssBaseline from '@mui/material/ScopedCssBaseline'
import { LoadingProvider } from '@context/LoadingContext'
import Indicator from '@components/Indicator'
import { Provider, useSelector, useDispatch } from 'react-redux'
import { Persistor } from './redux/store'
import { PersistGate } from 'redux-persist/integration/react'
import { Store } from './redux/store'
import { SnackbarProvider } from '@context/SnackbarContext'

import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
   <>
    <ScopedCssBaseline>
      <LoadingProvider>
        <SnackbarProvider>
          <Provider store={Store}>
            <PersistGate loading={null} persistor={Persistor}>
              <App />
            </PersistGate>
          </Provider>
        </SnackbarProvider>
        <Indicator />
      </LoadingProvider>
    </ScopedCssBaseline>
  </>
);

